export const MODULE_CREATE_RESET = 'MODULE_CREATE_RESET'
export const MODULE_CREATE_SET_CREATED = 'MODULE_CREATE_SET_CREATED'
export const MODULE_CREATE_SET_ERROR = 'MODULE_CREATE_SET_ERROR'
export const MODULE_CREATE_SET_VIOLATIONS = 'MODULE_CREATE_SET_VIOLATIONS'
export const MODULE_CREATE_TOGGLE_LOADING = 'MODULE_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/module/create/mutation_types.js